<div class="bg-white">
  <div class="lg:container lg:py-4 flex flex-row items-center justify-between">
    <div>
      <button (click)="goBack()" *ngIf="hasPrevious" class="btn-text flex flex-row items-center gap-2">
        <i class="icon-arrow-left"></i>
        <span class="hidden md:block">Προηγούμενο</span>
      </button>
    </div>

    <div class="flex flex-row items-center gap-4">
      <button (click)="skipStep()" *ngIf="hasSkip" class="btn-text">Παράλειψη</button>
      @if (!isLastStep) {
        <button (click)="goNext()" class="btn-primary flex flex-row items-center gap-2">
          <span class="hidden md:block">Επόμενο</span>
          <i class="icon-arrow-right"></i>
        </button>
      }@else {
        <a [localizedRouterLink]="[redirectLink]" class="btn-primary flex flex-row items-center gap-2">
          <span class="hidden md:block">Υποβολή</span>
          <i class="icon-arrow-right"></i>
        </a>
      }
    </div>
  </div>
</div>
